import React from 'react'

export default ({value, digits=2}) => {
  return (
    <span>
      {parseFloat(value).toLocaleString(undefined,{maximumFractionDigits:digits})}
    </span>
  )
}
